import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Factory لتحميل ملفات JSON
export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// Providers موحّد للاستخدام في standalone components
// NB : ne PAS ajouter provideHttpClient() ici — il est déjà fourni (avec ses
// intercepteurs) dans app.config.ts. Un second appel réenregistre HttpClient
// et fait perdre silencieusement la configuration d'intercepteurs.
export const translateProviders = [
  TranslateModule.forRoot({
    defaultLanguage: 'ar',
    loader: {
      provide: TranslateLoader,
      useFactory: httpLoaderFactory,
      deps: [HttpClient]
    }
  }).providers!
];
